import {
    RTMS_CONNECTED_STATE_SET,
    RTMS_MESSAGE_RECEIVED
} from '../_actions/types'
import {RTMSConnectionState, RTMSMessage} from '../types';

export type RTMSAction = {
    type: string;
    connectionState: RTMSConnectionState;
    message: RTMSMessage;
};

export type RTMSState = {
    connectedState: RTMSConnectionState,
    messages: RTMSMessage[]
};

const initialState: RTMSState = {
    connectedState: 'Disconnected',
    messages: []
};

export const reducer = (state: RTMSState = initialState, action: RTMSAction): RTMSState => {
    switch (action.type) {
        case RTMS_CONNECTED_STATE_SET:
            return {...state, connectedState: action.connectionState};
        case RTMS_MESSAGE_RECEIVED:
            return {
                ...state,
                messages: [
                    action.message,
                    ...state.messages
                ]
            };
        default:
            return state;
    }
};